import React, { useState } from 'react';
import { useDataProvider, useNotify, useRedirect, Title } from 'react-admin';

export const BulkAddCrashPresets = () => {
  const [mode, setMode] = useState('paste'); // 'paste' | 'generate'
  const [multipliers, setMultipliers] = useState('');
  const [count, setCount] = useState('');
  const [min, setMin] = useState('1.05');
  const [max, setMax] = useState('15.00');
  const [loading, setLoading] = useState(false);

  const dataProvider = useDataProvider();
  const notify = useNotify();
  const redirect = useRedirect();

  const parsePastedValues = () => {
    return multipliers
      .split(/[\n,]+/)
      .map((v) => v.trim())
      .filter((v) => v.length > 0)
      .map((v) => parseFloat(v))
      .filter((v) => !isNaN(v));
  };

  const generateRandomValues = () => {
    const n = parseInt(count, 10);
    const minVal = parseFloat(min);
    const maxVal = parseFloat(max);
    const values = [];
    for (let i = 0; i < n; i++) {
      const rand = Math.random() * (maxVal - minVal) + minVal;
      values.push(parseFloat(rand.toFixed(2)));
    }
    return values;
  };

  const handleAddAll = async () => {
    const values = mode === 'paste' ? parsePastedValues() : generateRandomValues();

    if (values.length === 0) {
      notify('কোনো valid multiplier পাওয়া যায়নি', { type: 'warning' });
      return;
    }

    setLoading(true);
    try {
      await Promise.all(
        values.map((multiplier) =>
          dataProvider.create('crash-presets', { data: { multiplier } })
        )
      );
      notify(`${values.length}টি crash preset সফলভাবে যোগ হয়েছে`, { type: 'success' });
      redirect('/crash-presets');
    } catch (error) {
      notify(`এরর হয়েছে: ${error.message}`, { type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: 20, maxWidth: 700 }}>
      <Title title="Bulk add crash presets" />
      <h2>Bulk add crash presets</h2>

      <div style={{ marginBottom: 16 }}>
        <label style={{ display: 'block', marginBottom: 8 }}>
          <input
            type="radio"
            checked={mode === 'paste'}
            onChange={() => setMode('paste')}
          />{' '}
          Paste specific values
        </label>
        <label style={{ display: 'block' }}>
          <input
            type="radio"
            checked={mode === 'generate'}
            onChange={() => setMode('generate')}
          />{' '}
          Auto-generate N random values in a range
        </label>
      </div>

      {mode === 'paste' && (
        <div style={{ marginBottom: 16 }}>
          <label>Multipliers:</label>
          <textarea
            rows={8}
            style={{ width: '100%', display: 'block' }}
            value={multipliers}
            onChange={(e) => setMultipliers(e.target.value)}
          />
          <small>Comma or newline separated. Example: 2.5, 1.2, 10.0, 3.4, 5.6</small>
        </div>
      )}

      {mode === 'generate' && (
        <div style={{ display: 'flex', gap: 16, marginBottom: 16 }}>
          <div>
            <label>How many to generate:</label>
            <input
              type="number"
              value={count}
              onChange={(e) => setCount(e.target.value)}
              placeholder="e.g. 10000"
            />
          </div>
          <div>
            <label>Minimum multiplier:</label>
            <input
              type="number"
              step="0.01"
              value={min}
              onChange={(e) => setMin(e.target.value)}
            />
          </div>
          <div>
            <label>Maximum multiplier:</label>
            <input
              type="number"
              step="0.01"
              value={max}
              onChange={(e) => setMax(e.target.value)}
            />
          </div>
        </div>
      )}

      <button onClick={handleAddAll} disabled={loading}>
        {loading ? 'Adding...' : 'Add all'}
      </button>
    </div>
  );
};